import React from 'react';

import { useField } from 'formik';

import TextInput from 'components-new/text-input/text-input';
import type { TextInputProps } from 'components-new/text-input/text-input';

interface PasswordFieldProps extends TextInputProps {
  name: string;
}

const PasswordField: React.FC<PasswordFieldProps> = (props) => {
  const { name, ...other } = props;
  const [field, meta] = useField(name);
  const [isOpen, flipState] = React.useReducer((state) => {
    return !state;
  }, false);

  return (
    <TextInput
      {...field}
      error={meta.touched ? meta.error : undefined}
      iconProps={{
        className: 'text-gray300',
        icon: isOpen ? 'eye-blocked' : 'eye',
        onClick: flipState,
        size: 20,
      }}
      {...other}
      type={isOpen ? 'text' : 'password'}
    />
  );
};

export default PasswordField;
